import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Pet, PetGender } from 'src/app/interfaces/pet';
import { KeeperResponseStatus } from 'src/app/interfaces/user';

import { PetService } from 'src/app/services/pet/pet.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { errorMessagesMap } from 'src/app/constants/error-messages';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-tok-consent',
  templateUrl: './tok-consent.component.html',
  styleUrls: ['./tok-consent.component.scss']
})

export class TokConsentComponent implements OnInit {
  alert: { type: string; message: SafeHtml } | null = null;
  chipNumber: string | null = null;
  autoResolveConsent: string | null = null;
  petName: string = ' - ';
  petSpecies: string = ' - ';
  dateOfBirth: Date | string = ' - ';
  implantDate: Date | string = ' - ';
  breed: string = ' - ';
  gender: PetGender | string = ' - ';
  petImagePath: string = '/assets/images/placeholders/paw.png';
  showButtons: boolean = true;
  cardBottomText: string;
  shouldShowCardBottomText: boolean;
  companyPhoneNumber: string;
  contactEmailAddress: string;
  isBrowser: boolean;
  useRebrandedLayout: boolean;

  constructor(
    private route: ActivatedRoute,
    private petService: PetService,
    private configService: ConfigService,
    private sanitizer: DomSanitizer,
    private featureFlagService: FeatureFlagsService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.companyPhoneNumber = this.configService.getTextFromKey('company-phone-number');
    this.contactEmailAddress = this.configService.getTextFromKey('contact-email-address');
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.useRebrandedLayout = this.featureFlagService.isEnabled('useRebrandedLayout');
  }

  ngOnInit(): void {
    this.shouldShowCardBottomText = !this.showButtons && this.alert === null;
    this.route.queryParamMap.subscribe(params => {
      this.chipNumber = params.get('chipnumber');
      this.autoResolveConsent = params.get('value');
    });
    if (this.chipNumber) {
      this.petService.getTokFromChipNumber(this.chipNumber).subscribe((data: Pet) => {
        this.petName = data.name;
        this.petSpecies = data.species;
        this.dateOfBirth = this.getDateOfBirthString(data.dob);
        this.implantDate = this.getDateOfBirthString(data.implantDate);
        this.breed = data.breed;
        this.gender = PetGender[data.gender];
        if (data.imageUrl) {
          this.petImagePath = data.imageUrl;
        }
      })
      if (this.autoResolveConsent && this.isBrowser) {
        this.showButtons = false
        const keeperResponseStatusToSend = Number(this.autoResolveConsent) === 0 ? KeeperResponseStatus.ConsentDeniedResponse : KeeperResponseStatus.ConsentGivenResponse
        this.consentGivenButtonsClick(keeperResponseStatusToSend);
      }
    }
  }

  private getDateOfBirthString(date: Date): string {
    const day = new Date(date).getDate();
    const month = new Date(date).getMonth() + 1;
    const year = new Date(date).getFullYear();
    return `${day}/${month}/${year}`;
  }

  closeAlert() {
    this.alert = null;
  }

  public consentGivenButtonsClick(keeperResponseStatus: KeeperResponseStatus) {
    this.petService.closeTokStatus(this.chipNumber, keeperResponseStatus).subscribe({
      next: () => {
        this.showButtons = false
        this.shouldShowCardBottomText = true;
        this.cardBottomText = keeperResponseStatus === KeeperResponseStatus.ConsentGivenResponse ? 
        "Thank you for your response, we will now update the keepership of this pet." :
        "Thank you for your response, a member of the team will be in touch in the next 48 hours to discuss this further.";
      },
      error: (err) => { 
        console.error(err);
        const rawError = err?.error;
        const errorList = Array.isArray(rawError) ? rawError : (rawError ? [rawError] : []);
        
        let unknownErrorShown = false;
        let messages: string[] = [];
        
        for (const error of errorList) {
          const key = error?.error_code;
          const rawMessage = errorMessagesMap[key];
          const msg = rawMessage?.replace('{{companyPhoneNumber}}', this.companyPhoneNumber.toString());

          if (msg) {
            messages.push(msg);
          } else if (!unknownErrorShown) {
            messages.push(`We're unable to process your request. Please reach out to our support team either by emailing ${this.contactEmailAddress} or call us on ${this.companyPhoneNumber}.`);
            unknownErrorShown = true;
          }
        }
        this.alert = {
          type: 'danger',
          message: this.sanitizer.bypassSecurityTrustHtml(messages.join('<br>'))
        };
      }
    });
  }
}
